import { z } from 'zod'

export const paramsSchema = z.object({
  cottageUid: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
